import type { Locale } from '../i18n';
import { useLocale } from '../i18n/LocaleProvider';
export function LanguageSwitcher({ locale, onChange }: { locale: Locale; onChange: (locale: Locale) => void }) {
  const { t } = useLocale();
  return <label style={{ display: 'grid', gap: 6 }}><span>{t('language')}</span><select className="hud-input" aria-label={t('language')} value={locale} onChange={(event) => { const next = event.target.value as Locale; onChange(next); }}><option value="zh-TW">繁體中文</option><option value="en">English</option></select></label>;
}
